import party, { Color, random } from 'party-js';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

// create ParticleContainer using party-js
// party.settings.debug = true;

function ParticleContainer({ shouldTrigger }: { shouldTrigger: boolean }) {
  useEffect(() => {
    if (shouldTrigger) {
      setTimeout(() => {
        party.confetti(document.getElementById('ready-text') as HTMLElement, {
          count: party.variation.range(20, 40),
          spread: party.variation.range(40, 60),
          color: () =>
            random.randomRange(0, 1) > 0.5 ? new Color(203, 255, 255) : new Color(0, 255, 248),
        });
      }, 250);
    }
  }, [shouldTrigger]);

  return <Particles id="party-js-container" />;
}

const Particles = styled.div`
  position: absolute;
  top: 0;
  overflow: hidden;

  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

export default ParticleContainer;
